module.exports = __webpack_public_path__ + "img/A低通锐化25.35b98c02.png";